<template>

  <!--刷新按钮-->
  <Tooltip content="点击重新获取最新数据">
    <Tag @click.native="refresh" color="#2EF1F3"><Icon style="position: relative; top: -1px;" class="item-icon" type="md-refresh" size="18"></Icon> 刷新数据</Tag>
  </Tooltip>

</template>

<script>
export default {
  name: "funcBar",
  inject:['reload'],
  methods:{
    refresh(){
      this.reload();
    }
  }
};
</script>

<style scoped>
</style>
